import LayoutPages from "@/layout/Layout2";

export default [
  {
    path: "/repository",
    component: LayoutPages,
    children: [
      {
        path: "list",
        component: () => import("@/views/repository/List"),
      },
      {
        path: "edit",
        component: () => import("@/views/repository/AddEditFileRepository"),
      },
    ],
  },
];
